import { render, staticRenderFns } from "./CustomerProfileHistory.vue?vue&type=template&id=c34dc0d6&scoped=true"
import script from "./CustomerProfileHistory.vue?vue&type=script&lang=js"
export * from "./CustomerProfileHistory.vue?vue&type=script&lang=js"
import style0 from "./CustomerProfileHistory.vue?vue&type=style&index=0&id=c34dc0d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34dc0d6",
  null
  
)

export default component.exports